import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  body {
    width: 100vw;
    height: 100vh;
    margin: initial;
  }

  #root {
    width: 100%;
    height: 100%;
  }
`;

export default GlobalStyle;
